import {
  COMPANIES_SLUG,
  CURRENT_JOBS_SLUG,
  DASHBOARD_SLUG,
  INFORMATION_SLUG,
  OPERATIONS_SLUG,
  OPPORTUNITIES_SLUG,
  OVERVIEW_SLUG,
  PAST_JOBS_SLUG,
  PREVIOUS_REPORTS_SLUG,
  SETTINGS_SLUG,
  SUBSCRIPTION_SLUG,
  WORKBOARD_SLUG,
} from 'dashboard409a/common/constants/urls';


export const DASHBOARD_COMPANY_SLUG = `/${DASHBOARD_SLUG}/${COMPANIES_SLUG}/:companySlug`;
export const DASHBOARD_COMPANY_OVERVIEW_SLUG = `${DASHBOARD_COMPANY_SLUG}/${OVERVIEW_SLUG}`;
export const DASHBOARD_COMPANY_PREVIOUS_REPORTS_SLUG = `${DASHBOARD_COMPANY_SLUG}/${PREVIOUS_REPORTS_SLUG}`;
export const DASHBOARD_COMPANY_OPERATIONS = `${DASHBOARD_COMPANY_SLUG}/${OPERATIONS_SLUG}`;
export const DASHBOARD_COMPANY_SETTINGS = `${DASHBOARD_COMPANY_SLUG}/${SETTINGS_SLUG}`;
export const DASHBOARD_COMPANY_SUBSCRIPTION = `${DASHBOARD_COMPANY_SLUG}/${SUBSCRIPTION_SLUG}`;
export const DASHBOARD_COMPANY_INFORMATION = `${DASHBOARD_COMPANY_SLUG}/${INFORMATION_SLUG}`;

export const DASHBOARD_WORKBOARD_SLUG = `/${WORKBOARD_SLUG}`;
export const DASHBOARD_WORKBOARD_CURRENT_JOBS = `${DASHBOARD_WORKBOARD_SLUG}/${CURRENT_JOBS_SLUG}`;
export const DASHBOARD_WORKBOARD_PAST_JOBS = `${DASHBOARD_WORKBOARD_SLUG}/${PAST_JOBS_SLUG}`;
export const DASHBOARD_WORKBOARD_OPPORTUNITIES = `${DASHBOARD_WORKBOARD_SLUG}/${OPPORTUNITIES_SLUG}`;

export const IS_WORKBOARD = [CURRENT_JOBS_SLUG, PAST_JOBS_SLUG, OPPORTUNITIES_SLUG];
export const IS_REPORTS_PAGE = [COMPANIES_SLUG, `/${DASHBOARD_SLUG}/${COMPANIES_SLUG}/`];